var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /photo-order/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15b52f12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/photo-order/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/Header.vue
// module id = null
// module chunks = 